import { TFunction } from 'i18next';
import { object } from 'yup';

import { CheckSingleSignOnEmail } from 'src/shared/hooks/useSingleSignOn';
import { logFactory } from 'src/shared/log';
import { makeEmail, makePassword } from 'src/shared/validationSchemas';

const log = logFactory('login:components:Login:Form:validationSchema');

const makePasswordValidationSchema = (t: TFunction) =>
  object().shape({
    email: makeEmail(t),
    password: makePassword(t),
  });

const makeSingleSignOnValidationSchema = (
  t: TFunction,
  checkEmail: CheckSingleSignOnEmail | null,
) =>
  object().shape({
    email: makeEmail(t).test(
      'isSingleSignOnEnabled',
      t('singleSignOn.thisEmailIsNotSSOEnabled'),
      async email => {
        if (!makeEmail(t).isValidSync(email) || !checkEmail) return false;

        log('🔎 Checking email...', email);

        return checkEmail(email);
      },
    ),
  });

export { makePasswordValidationSchema, makeSingleSignOnValidationSchema };
